import { Grid, Typography, useTheme } from "@mui/material";
import React from "react";

export default function InfoContainer(props) {
  const { title, titleSx, body, bodySx, sx, ActionButton } = props;

  const theme = useTheme();

  return (
    <Grid
      container
      sx={{
        width: "100%",
        textAlign: "center",
        gap: 2,
        border: `3px solid ${theme.palette.divider}`,
        borderRadius: 1,
        p: 4,
        wordWrap: "break-word",
        ...sx,
      }}
      pl={[2, 6]}
      pr={[2, 6]}
    >
      {title && (
        <Grid item xs={12}>
          <Typography variant="h3" sx={{ fontWeight: "700", ...titleSx }}>
            {title}
          </Typography>
        </Grid>
      )}

      {body && (
        <Grid item xs={12}>
          <Typography variant="body1" sx={{ ...bodySx }}>
            {body}
          </Typography>
        </Grid>
      )}

      {ActionButton && (
        <Grid item xs={12}>
          {ActionButton}
        </Grid>
      )}
    </Grid>
  );
}
